/* ------------------ Allowable file extensions ------------------ */
export const CODE_FILE_EXTENSIONS = [
    'as',
    'as3',
    'asm',
    'bat',
    'c',
    'cc',
    'cmake',
    'cpp',
    'cs',
    'css',
    'cxx',
    'diff',
    'erb',
    'groovy',
    'h',
    'haml',
    'hh',
    'htm',
    'html',
    'java',
    'js',
    'json',
    'less',
    'm',
    'make',
    'md',
    'ml',
    'mm',
    'php',
    'pl',
    'plist',
    'properties',
    'py',
    'rb',
    'rst',
    'sass',
    'scala',
    'script',
    'scm',
    'sml',
    'sql',
    'sh',
    'vi',
    'vim',
    'webdoc',
    'xhtml',
    'yaml',
];

export const DOCUMENT_FILE_EXTENSIONS = [
    'csv',
    'doc',
    'docx',
    'dwg',
    'gdoc',
    'gsheet',
    'gslide',
    'gslides',
    'idml',
    'indd',
    'indt',
    'inx',
    'key',
    'numbers',
    'odp',
    'ods',
    'odt',
    'pages',
    'pdf',
    'ppt',
    'pptx',
    'rtf',
    'wpd',
    'xls',
    'xlsm',
    'xlsx',
];

export const TEXT_FILE_EXTENSIONS = [
    'as',
    'as3',
    'asm',
    'bat',
    'c',
    'cc',
    'cmake',
    'cpp',
    'cs',
    'css',
    'cxx',
    'diff',
    'erb',
    'groovy',
    'h',
    'haml',
    'hh',
    'java',
    'js',
    'json',
    'less',
    'log',
    'm',
    'make',
    'md',
    'ml',
    'mm',
    'php',
    'pl',
    'plist',
    'properties',
    'py',
    'rb',
    'rst',
    'sass',
    'scala',
    'script',
    'scm',
    'sml',
    'sql',
    'sh',
    'txt',
    'vi',
    'vim',
    'webdoc',
    'yaml',
];

export const SPREADSHEET_FILE_EXTENSIONS = ['xls', 'xlsx', 'xlsm', 'xlsb', 'csv', 'ods', 'gsheet'];

export const DOCUMENT_SUGGESTED_QUESTIONS = [
    {
        id: 'suggested-question-1',
        labelId: 'documentSuggestedQuestionLabel1',
        promptId: 'documentSuggestedQuestionPrompt1',
    },
    {
        id: 'suggested-question-2',
        labelId: 'documentSuggestedQuestionLabel2',
        promptId: 'documentSuggestedQuestionPrompt2',
    },
    {
        id: 'suggested-question-3',
        labelId: 'documentSuggestedQuestionLabel3',
        promptId: 'documentSuggestedQuestionPrompt3',
    },
    {
        id: 'suggested-question-4',
        labelId: 'documentSuggestedQuestionLabel4',
        promptId: 'documentSuggestedQuestionPrompt4',
    },
];
